import React from 'react'
import styled from 'styled-components'
import { Button } from 'reactstrap'
import { getAppConfig } from 'deploy-env/app-config'

import IconAccess from 'assets/images/nav/icon-iamc-unaccess.svg'
import IconUser from 'assets/images/nav/icon-User-Active.svg'
import { getToggles } from 'quick-quote/feature-toggles'
import { clickHomeButton, logoutRequest } from '../actions'

import { FullScreenPopup } from './global-popup'
import MESSAGES from 'core/data-model/constants/messages'
import { useDispatch } from 'react-redux'

const Heading = styled.h4`
  font-weight: bold;
  font-size: 28px;
  line-height: 32px;
  color: var(--color-primary-blue);
`
const Icon = styled.img`
  width: 200px !important;
  height: 200px;
`

const IconRenderUser = styled.img`
  width: 25px !important;
  height: 25px !important;
  display: inline !important;
`

export const AuthenticationError = (props) => {
  const { notificationMessage } = props
  let urlSearchParams = new URLSearchParams(window.location.search)
  if (window.cordova) {
    const dataHash = window.location.hash.split('?')
    urlSearchParams = new URLSearchParams(dataHash.length > 1 ? dataHash[1] : '')
  } else {
    urlSearchParams = new URLSearchParams(window.location.search)
  }
  const params = Object.fromEntries(urlSearchParams.entries())

  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(logoutRequest())
  }

  let msg = {
    title: '',
    description: '',
  }
  const renderSwitch = (param) => {
    switch (param) {
      case 'password is expired':
        msg.title = 'บัญชีชื่อผู้ใช้งานของท่าน รหัสผ่านหมดอายุ'
        msg.description =
          'กรุณากด “ลืมรหัสผ่าน” เพื่อขอรับลิงก์ตั้งรหัสผ่านใหม่ สำหรับบริการช่วยเหลือแนะนำการใช้งาน กรุณาติดต่อแอดมินของทีมฝ่ายขาย หรือศูนย์ลูกค้าสัมพันธ์ โทร.1159 กด 5 หรือ iPro'
        return msg

      case 'user is terminated':
        msg.title = 'บัญชีชื่อผู้ใช้งานของท่านไม่สามารถใช้งานได้'
        msg.description =
          'สำหรับบริการช่วยเหลือแนะนำการใช้งาน กรุณาติดต่อแอดมินของทีมฝ่ายขาย หรือศูนย์ลูกค้าสัมพันธ์ โทร.1159 กด 5 หรือ iPro'
        return msg

      case 'lbCode terminated':
        msg.title = MESSAGES.INACTIVE_USER_ERROR_MSG
        msg.description =
          'สำหรับบริการช่วยเหลือแนะนำการใช้งาน กรุณาติดต่อแอดมินของทีมฝ่ายขาย หรือศูนย์ลูกค้าสัมพันธ์ โทร.1159 กด 5 หรือ iPro'
        return msg

      case 'user is blocked':
        msg.title = 'บัญชีชื่อผู้ใช้งานของท่านถูกระงับโดยผู้ดูแลระบบ'
        msg.description =
          'สำหรับบริการช่วยเหลือแนะนำการใช้งาน กรุณาติดต่อแอดมินของทีมฝ่ายขาย หรือศูนย์ลูกค้าสัมพันธ์ โทร.1159 กด 5 หรือ iPro'
        return msg
      default:
        msg.title = (
          <p>
            • บัญชีผู้ใช้ของท่านหมดอายุ
            <br /> • บัญชีผู้ใช้ของท่านไม่ได้ใช้งานเป็นระยะเวลานาน
            <br /> • รหัสผ่านของท่านหมดอายุ
          </p>
        )
        msg.description = (
          <p>
            กรุณากดปุ่ม ออกจากระบบที่รูปคนมุมขวาบน
            <IconRenderUser src={IconUser} /> หรือ ตรวจสอบกับทางแอดมินของทางทีมฝ่ายขายเพื่อแนะนำวิธี
          </p>
        )
        return msg
    }
  }
  const decodeParam = params.error_description?.length ? decodeURIComponent(params.error_description) : undefined
  const result = renderSwitch(decodeParam)

  return (
    <FullScreenPopup className="iamc-modal" isOpen={notificationMessage.type !== 'None'}>
      <div className="iamc-modal__wrapper">
        <Icon src={IconAccess} />

        <div className="description">
          {getToggles().ENABLE_NEW_SESSION_ERROR_MESSAGE && (
            <Heading data-testid="auth-error-msg">
              ท่านไม่สามารถใช้งานแอปพลิเคชัน กรุณาตรวจสอบบัญชีผู้ใช้ของท่าน
            </Heading>
          )}

          {result && (
            <div className="form-group has-danger">
              {result.title && (
                <div className="validation-message attached-icon form-control-feedback iam-c">
                  <p>{result?.title}</p>
                </div>
              )}
              {result.description && (
                <div className="info-message attached-icon form-control-feedback iam-c">
                  <p>{result?.description}</p>
                </div>
              )}
            </div>
          )}
        </div>

        <Button color="primary" onClick={onClose} data-testid="auth-error-btn-close">
          {!getToggles().ENABLE_NEW_SESSION_ERROR_MESSAGE && 'ปิด'}
          {getToggles().ENABLE_NEW_SESSION_ERROR_MESSAGE && 'ปิดหน้านี้'}
        </Button>
      </div>
    </FullScreenPopup>
  )
}

export default AuthenticationError
